import React from "react";
import IconTrash from "../../Assets/images/icon-trash.svg";

const RemoveBreachInfo = (props: any) => {
    return (
        <>
            <div className="dialog-header" style={{ display: "flex" }}>
                <div className="dialog-icon status-default" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={IconTrash} alt="trashcan icon" />
                </div>
            </div>
            <div className={props.isLoading ? "loading dialog-body" : "dialog-body"}>
                <div className="row">
                    <h2 className="box-title" style={{ paddingTop: "5px", color: "#00313c" }}>
                        Remove <span className="breach-text-search">{props.organization}</span> from Saved Searches?
                    </h2>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row">
                    <div className="col-xs-12 col-no-gutter flex-grow-null" style={{ display: "flex", justifyContent: "space-between" }}>
                        <button type="button" className="btn-default" onClick={props.closeDialog}>
                            <span className="btn-text">Cancel</span>
                        </button>
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            onClick={() => {
                                window.addToDataLayer({ event: "breachIQBtnRemoveSavedSearch" });
                                props.handleRemove();
                            }}
                        >
                            <span className="btn-text">Remove</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RemoveBreachInfo;
